import React from 'react'

import Text from 'components/typo/Text'
import Button from '../Button'

import classnames from 'classnames/bind'
import css from './styles.module.scss'
import Image from 'components/shared/Image'

const cx = classnames.bind(css)
const ConfiguredFeatureCard = ({
  icon,
  title,
  text,
  button,
  image,
  index,
  upperTitle,
  cardConfig,
}) => {
  const isButton = button && button.text && button.href
  return (
    <div
      className={cx(css.wrapper, {
        [css.flexRow]: cardConfig === 'fullWidth',
        [css.flexRowReverse]: cardConfig === 'fullWidthReverseImage',
        [css.halfWidth]: cardConfig === 'halfWidth',
        [css.thirdWidth]: cardConfig === 'thirdWidth',
        [css.wrapperRow]: cardConfig !== 'halfWidth',
        [css.wrapperColumn]: cardConfig === 'halfWidth',
      })}
    >
      <div
        className={cx(css.leftSide, {
          [css.paddingLarge]: cardConfig !== 'thirdWidth' || cardConfig !== 'halfWidth' ,
          [css.paddingMedium]: cardConfig === 'halfWidth',
          [css.paddingSmall]: cardConfig === 'thirdWidth',
          [css.paddingHalf]: cardConfig === 'halfWidth',
        })}
      >
        <div className={css.header}>
          {cardConfig === 'thirdWidth' && (
            <Image
              className={css.dynamicIcon}
              media={{ width: 32, height: 32 }}
              fluid
              {...icon}
              alt={
                image?.media?.data?.attributes?.alternativeText ?? 'card-image'
              }
              notAbsolute
            />
          )}
          {title && (
          <div
            className={cx(css.titleRow, {
              [css.alignCenter]: !upperTitle,
            })}
          >
            {cardConfig !== 'thirdWidth' && (
              <Image
                className={css.icon}
                media={{ width: 32, height: 32 }}
                fluid
                {...icon}
                alt={
                  icon?.media?.data.attributes.alternativeText ?? 'icon-image'
                }
                notAbsolute
              />
            )}
            <div>
              <Text className={css.title}>{title}</Text>
            </div>
          </div>
          )}
          <Text className={css.description}>{text}</Text>
          {isButton && (
            <Button
              theme="white"
              className={css.btn}
              href={button.href}
              target={button.target ?? 'blank'}
              buttonClassName={css.buttonClassName}
            >
              <span>{button.text}</span>
            </Button>
          )}
          {isButton && (
            <Button
              theme="link"
              className={css.linkBtn}
              href={button.href}
              target={button.target ?? 'blank'}
              buttonClassName={css.buttonClassName}
            >
              <span>{button.text}</span>
            </Button>
          )}
        </div>
      </div>
      {image && (
        <Image
          className={cx({
            [css.image]: cardConfig !== 'thirdWidth ||' || cardConfig !== 'halfWidth',
            [css.imageHalf]: cardConfig === 'halfWidth',
            [css.noImage]: cardConfig === 'thirdWidth',
          })}
          media={{ width: 32, height: 32 }}
          fluid
          {...image}
          alt={image?.media?.data?.attributes?.alternativeText ?? 'card-image'}
        />
      )}
    </div>
  )
}

export default ConfiguredFeatureCard